import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import Tabs from './Tabs';
import { Carousel } from 'antd';
import moment from 'moment';
import { str } from '../../utils';
import NoneData from '../common/NoneData';
export class Message extends Component {
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    defaultActiveKey: 0,
    detail: '', //消息详情
    MessageContent: '',
    // MessageType: 0,
    // MessageLinkType: 0,
    MessageTitle: '',
  };
  componentDidMount() {
    // this.props.actions.fetchMessageData({ SortType: 0 }).then(res => {
    //   if (res.SuccessResponse) {
    //     let search = this.props.history.location.search;
    //     if (search) {
    //       let messageId = parseInt(search.slice(search.indexOf("=") + 1, search.length), 10);
    //       for (let i = 0; i < res.Data.length; i++) {
    //         const ele = res.Data[i];
    //         if (ele.MessageID === messageId) {
    //           this.JumptoDetail(ele);
    //         }
    //       }
    //     }
    //   }
    // });
    this.props.actions.fetchStudentPublicList().then(res => {
      if (res.SuccessResponse) {
        let search = this.props.history.location.search;
        if (search) {
          let messageId = parseInt(search.slice(search.indexOf('=') + 1, search.length), 10);
          for (let i = 0; i < res.Data.length; i++) {
            const ele = res.Data[i];
            if (ele.MessageId === messageId) {
              this.JumptoDetail(ele);
            }
          }
        }
      }
    });
  }
  JumptoDetail(item) {
    this.setState(
      {
        detail: item.PopupUrl,
        MessageTitle: item.Title,
        MessageContent: item.MessageContent,
      },
      () => {
        this.refs.carousel.next();
        this.updateRouter(item);
      },
    );
  }
  updateRouter(item) {
    this.props.history.replace(`/center/message/0?MessageID=${item.MessageId}`);
  }
  onBackList() {
    this.refs.carousel.prev();
    this.props.history.replace(`/center/message/0`);
  }
  render() {
    const { defaultActiveKey, detail, MessageTitle, MessageContent } = this.state;
    let { messageData } = this.props.home;
    console.log(detail);
    return (
      <div className="center-message">
        <div className="tabs">
          <Tabs {...this.props} defaultActiveKey={defaultActiveKey} tabs={[{ Name: '消息' }]} />
        </div>
        <div className="center-message-content">
          <Carousel dots={false} ref="carousel">
            <div className="center-message-list">
              <h1>
                <p>共{messageData.length}条消息</p>
              </h1>
              {messageData.length > 0 && (
                <ul>
                  {messageData.map(item => (
                    <li
                      key={item.MessageId}
                      onClick={() => {
                        this.JumptoDetail(item);
                      }}
                    >
                      <p>
                        {item.IsTopping ? '【置顶】' : ''}
                        {item.Title}
                      </p>
                      <p>{moment(new Date(item.ReleaseTime)).format('YYYY-MM-DD HH:mm:ss')}</p>
                    </li>
                  ))}
                </ul>
              )}
              {messageData.length === 0 && (
                <div className="noneData">
                  <NoneData type={2} />
                </div>
              )}
            </div>
            <div className="center-message-detail">
              <h1>
                <p>消息详情</p>
                <p onClick={this.onBackList.bind(this)}>返回消息列表</p>
              </h1>
              <h2>{MessageTitle}</h2>
              <div
                className="center-message-detail-content"
                dangerouslySetInnerHTML={{ __html: str.unescapeHTML(MessageContent) }}
              ></div>
              {/* {
                MessageType === 0 ? <div className="center-message-detail-content" dangerouslySetInnerHTML={{ __html: detail }} />
                  :
                  <div className="center-message-detail-content"><a href={detail}>内部链接</a></div>
              } */}
            </div>
          </Carousel>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Message);



// WEBPACK FOOTER //
// ./src/features/center/Message.js